import React, { useMemo } from "react";
import BottomKPIBar, {
  KPI
} from "@/components/controls/BottomKPIBar/BottomKPIBar";

interface PartnerContactsKPIData extends Record<string, number> {
  total: number;
}

interface Props {
  totalPartnerContacts: number;
  isLoading?: boolean;
  onOpenStateChange?: (isOpen: boolean) => void;
}

const PartnerContactsBottomKPIBar: React.FC<Props> = ({
  totalPartnerContacts,
  isLoading = false,
  onOpenStateChange
}) => {
  const kpis: KPI<PartnerContactsKPIData>[] = [{ name: "total" }];

  const data: PartnerContactsKPIData = useMemo(
    () => ({ total: totalPartnerContacts }),
    [totalPartnerContacts]
  );

  return (
    <BottomKPIBar<PartnerContactsKPIData>
      kpis={kpis}
      data={data}
      pageName="partnercontacts"
      isLoading={isLoading}
      onOpenStateChange={onOpenStateChange}
    />
  );
};

export default PartnerContactsBottomKPIBar;
